import { apiUrls, authBaseUrl } from '../../constants/appConstants';
import { apiSlice } from '../services/apiSlice';

// Auth routes call the central auth server (SynapseAuth) DIRECTLY via absolute
// URLs — RTK Query uses an absolute `url` as-is, bypassing the backend baseUrl.
// The prepareHeaders Bearer token still rides along (needed for password/change).
// getMyProfile stays on the Synapse backend (relative url).
const AUTH = `${authBaseUrl}/v1/auth`;

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // body: { email, password } → { access, refresh, sub }
    signin: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/login`,
          method: 'POST',
          body: {
            identifier: body?.email || body?.login_id,
            password: body?.password,
            app: 'synapse',
            platform: 'admin',
            device: { platform: 'web', fcm_token: body?.fcm_token ?? null },
          },
        };
      },
    }),

    // Sends a reset OTP. body: { email }
    forgotPassword: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/otp/request`,
          method: 'POST',
          body: { identifier: body?.email, purpose: 'reset', app: 'synapse' },
        };
      },
    }),

    // body: { otp, email } → { challenge_token }
    verifyOtp: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/otp/verify`,
          method: 'POST',
          body: { identifier: body?.email, code: body?.otp, purpose: 'reset', app: 'synapse' },
        };
      },
    }),

    // Authenticated change (Bearer). body: { old_password, new_password }
    changePassword: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/password/change`,
          method: 'POST',
          body: {
            old_password: body?.old_password,
            new_password: body?.new_password ?? body?.password,
          },
        };
      },
    }),

    // Consume the reset challenge. body: { challenge_token, password }
    resetPassword: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/password/reset`,
          method: 'POST',
          body: { challenge_token: body?.challenge_token, new_password: body?.password },
        };
      },
    }),

    // body: { refresh }
    signout: builder.mutation({
      query(body) {
        return {
          url: `${AUTH}/logout`,
          method: 'POST',
          body: { refresh: body?.refresh },
        };
      },
    }),

    getMyProfile: builder.query({
      query(_params) {
        return {
          url: `${apiUrls.getMyProfile}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useSigninMutation,
  useForgotPasswordMutation,
  useVerifyOtpMutation,
  useChangePasswordMutation,
  useResetPasswordMutation,
  useSignoutMutation,
  useGetMyProfileQuery,
  useLazyGetMyProfileQuery,
} = authApi;
